import "./productTableInCart.css"
import { useGlobalContext } from "../../context";
import CurrencyFormat from "react-currency-format"
import { FaTrashCan } from "react-icons/fa6";
import { useEffect } from "react";


function ProductTableInCart(props) {
    const { cart, removeFromCart, changeQuentityInCart , setRoute } = useGlobalContext()
    useEffect(() => {
        setRoute(props.route)
    } , [])
    return (
        <>
            <table className="c-table">
                <thead>
                    <tr>
                        <th>نام کالا</th>
                        <th>قیمت</th>
                        <th>تعداد</th>
                        <th>قیمت نهایی</th>
                    </tr>
                </thead>
                {
                    cart.length >= 1 &&
                    cart.map((item, i) => {
                        return (
                            <tbody key={i}>
                                <tr>
                                    <td className="img-c-pro">
                                        <button onClick={() => removeFromCart(item.code, item.size)}>
                                            <FaTrashCan size={15} />
                                        </button>
                                        <img src={item.img[0]} alt="" />
                                        <div>
                                            <div>
                                                <span>نام :</span>
                                                <span>{item.name}</span>
                                            </div>
                                            <div>
                                                <span>کد :</span>
                                                <span>{item.code}</span>
                                            </div>
                                            {/* <div>
                                            <span>رنگ :</span>
                                            <span>مشکی</span>
                                        </div> */}
                                            <div>
                                                <span>سایز :</span>
                                                <span>{item.size}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="price-c-pro">
                                        <span>قیمت : </span>
                                        <CurrencyFormat thousandSeparator={true}
                                            value={item.price}
                                            prefix="تومان"
                                            displayType="text">
                                        </CurrencyFormat>
                                    </td>
                                    <td className="qty-c-pro">
                                        <button onClick={() => changeQuentityInCart(item.code, item.size, "I", item.store)}>+</button>
                                        <span>{item.qty}</span>
                                        <button onClick={() => changeQuentityInCart(item.code, item.size, "D", item.store)}>-</button>
                                    </td>
                                    <td className="total-c-pro">
                                        <span>مجموع : </span>
                                        <CurrencyFormat thousandSeparator={true}
                                            value={item.price * item.qty}
                                            prefix="تومان"
                                            displayType="text">
                                        </CurrencyFormat>
                                    </td>
                                </tr>
                            </tbody>
                        )
                    })
                }
            </table>
            {
                cart.length == 0 &&
                <h1 style={{ background: "lightgray", textAlign: "center" }}>
                    محصولی در سبد خرید وجود ندارد.
                </h1>
            }
        </>
    )
}
export default ProductTableInCart;